import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Title from "@/components/atoms/BaseTitle.vue";
import Paragraph from "@/components/atoms/BaseParagraph.vue";

// Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

// Component types & definitions
import {
  VariantKeys as paragraphTitleVariantKeys,
  VariantsType as paragraphTitleVariantKeysType,
  variantCombination as paragraphTitleVariantCombination,
  sizeCombination,
} from "@/components/molecules/paragraphTitle/ParagraphTitle";


export default /*@__PURE__*/_defineComponent({
  __name: 'ParagraphTitle',
  props: {
    variant: { default: paragraphTitleVariantKeys.primary },
    size: { default: SizesKeys.default },
    title: { default: undefined },
    message: { default: undefined }
  },
  setup(__props: any) {

//Components


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Title, {
      variant: _unref(paragraphTitleVariantCombination)[_ctx.variant].title,
      size: _unref(sizeCombination)[_ctx.size].title,
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["variant", "size"]),
    _createVNode(Paragraph, {
      variant: _unref(paragraphTitleVariantCombination)[_ctx.variant].paragraph,
      size: _unref(sizeCombination)[_ctx.size].paragraph
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.message), 1)
      ]),
      _: 1
    }, 8, ["variant", "size"])
  ]))
}
}

})